// STAGING
// export const username = 'back-office-internal';
// export const password = 'Jktw3XH0GEoYC9rZkVK1';
// export const loanPublisherUsername = 'loan-publisher-internal';
// export const loanPublisherPassword = 'xTncykgMjNeYuH7vrVk2NCND';

// PROD
export const username = 'back-office-internal-prod';
export const password = 'A7em2u8VMpoWGd7ocaKB';
export const loanPublisherUsername = 'loan-publisher-internal';
export const loanPublisherPassword = '9UcbS8LM52ZJje5AgY2EhSz3';
